import { ClientSetup } from './models/client-setup';
import { ClientSponsorGroup } from './models/client-sponsor-group';
import { DrugPricing } from './models/drug-pricing';
import { GridPageResult } from '../../lib/shared/grid-page-result';
import { GroupData } from './models/group-data';
import { Guid } from '../../lib/shared/guid';
import { Host } from '../../lib/shared/host';
import { HttpRequest } from '../../lib/shared/http-request';
import { HttpRequestVerbs } from '../../lib/shared/http-request-verbs';
import { HttpResponse } from '../../lib/shared/http-response';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Pharmacy } from './models/pharmacy';
import { PharmacyInput } from './models/pharmacy-input';
import { PharmacyNetwork } from './models/pharmacy-network';
import { Phdem } from './models/phdem';
import { ServiceProxyBase } from '../../lib/services/service-proxy-base';
import { BoundingBox } from "./models/BoundingBox";
import { BoundingRadius } from "./models/BoundingRadius";
import { State } from './models/state';
import { Uri } from '../../lib/shared/uri';
import { Geocode } from './models/geocode';

@Injectable()
export class PharmacyLocatorService {
    accessToken: string;
    constructor(private serviceProxy: ServiceProxyBase) { }



    //getClientUsesPharmacyLocatorMap() {
    //    const httpRequest = new HttpRequest();
    //    httpRequest.token = this.accessToken;
    //    httpRequest.verb = HttpRequestVerbs.POST;
    //    httpRequest.uri.host.name = 'PharmacyLocator';
    //    httpRequest.uri.path = `/Pharmacy/UseMap`;
    //    httpRequest.body = "";

    //    const response = this.serviceProxy.post<any, any>(httpRequest);
    //    return response;

    //}



    getClientMapSettings() {
        const httpRequest = new HttpRequest();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Pharmacy/GetMapSettings`;
        httpRequest.body = "";

        const response = this.serviceProxy.post<any, any>(httpRequest);
        return response;
    }
    /*
      ClientSetup
    */

    // [HttpGet, Route("ClientSetup")]
    // public IActionResult Get()
    getClientSetup() {
        const httpRequest = new HttpRequest();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/ClientSetup`;

        const response = this.serviceProxy.post<any, GridPageResult<ClientSetup>>(httpRequest);
        return response;
    }

    // [HttpGet, Route("ClientSetup/{id}")]
    // public IActionResult Get(Guid id)
    getClientSetupById(id: Guid) {
        const httpRequest = new HttpRequest();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/ClientSetup/${id}`;

        const response = this.serviceProxy.post<any, ClientSetup>(httpRequest);
        return response;
    }

    // [HttpGet, Route("ClientSetup/Group/{LookupValue}/{ClientID:int}")]
    // public IActionResult Get(string LookupValue, int ClientID)
    getClientSetupByGroup(lookupValue: string, lookupType: string, clientId: number) {
        const httpRequest = new HttpRequest();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/ClientSetup/Group/${lookupValue}/${clientId}`;

        const response = this.serviceProxy.post<any, any>(httpRequest);
        return response;
    }

    // [HttpPost, Route("ClientSetup")]
    // public IActionResult Post([FromBody]ClientSetupDto input)
    postClientSetup(clientSetup: ClientSetup) {
        const httpRequest = new HttpRequest<ClientSetup>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/ClientSetup`;
        httpRequest.body = clientSetup; // input

        const response = this.serviceProxy.post<ClientSetup, ClientSetup>(httpRequest);
        return response;
    }

    /*
      Possible outcomes:
      I.  invalid
          A. return 400
      II. valid
          A. existing clientsetup
             1.  Changes
                 a. GET - return ClientSetupDto
             2.  No Changes
                 a. return 204
          B. new clientsetup
             1.  POST - return ClientSetupDto
      III. error
          A. ConcurrencyError
          B. ControllerError
    */

    // [HttpPut, Route("[controller]")]
    // public IActionResult Put([FromBody]ClientSetupDto input)
    putClientSetup(clientSetup: ClientSetup) {
        const httpRequest = new HttpRequest<ClientSetup>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.PUT;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/ClientSetup`;

        const response = this.serviceProxy.post<ClientSetup, ClientSetup>(httpRequest);
        return response;
    }

    /*
      ClientSponsorGroups
    */

    // [HttpGet, Route("ClientSponsorGroups/{ClientID}")]
    // public IActionResult Get(int ClientID)
    getClientSponsorGroups(clientId: number) {
        const httpRequest = new HttpRequest<ClientSetup>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/ClientSponsorGroups/${clientId}`;

        const response = this.serviceProxy.post<{}, ClientSponsorGroup>(httpRequest);
        return response;
    }

    // [HttpPost, Route("ClientSponsorGroups/{ClientID}")]
    // public IActionResult Post(int ClientID, [FromBody]ClientSponsorGroupDto input)
    postClientSponsorGroups(input: ClientSponsorGroup, clientId: number) {
        const httpRequest = new HttpRequest<ClientSponsorGroup>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/ClientSponsorGroups/${clientId}`;
        httpRequest.body = input;

        const response = this.serviceProxy.post<ClientSponsorGroup, ClientSponsorGroup>(httpRequest);
        return response;
    }

    /*
      DrugPricing
    */

    // [HttpPost, Route("DrugPricing")]
    // public IActionResult Get([FromBody]DrugPricingDto Input)
    postDrugPricing(drugPricingDto: DrugPricing) {
        const httpRequest = new HttpRequest<DrugPricing>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/DrugPricing`;
        httpRequest.body = drugPricingDto;

        const response = this.serviceProxy.post<DrugPricing, DrugPricing>(httpRequest);
        return response;
    }

    /*
      Geocode
    */

    // [HttpGet, Route("Geocode/location/{Address}")]
    // public IActionResult GetAddress(string ClientID, string Address)
    getAddress(address: string, clientId: string) {
        const httpRequest = new HttpRequest<BoundingBox>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `Geocode/location/${address}`;
        httpRequest.addQueryParameter('ClientID', clientId);

        const response = this.serviceProxy.post<BoundingBox, Array<Pharmacy>>(httpRequest);
        return response;
    }

    // [HttpGet, Route("Geocode")]
    // public IActionResult Get()
    get() {
        const httpRequest = new HttpRequest<{}>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Geocode`;

        const response = this.serviceProxy.post<{}, Geocode>(httpRequest);
        return response;
    }

    // [HttpPost, Route("Geocode")]
    // public IActionResult Post([FromBody]PharmacyInput Input)
    post(input: PharmacyInput) {
        const httpRequest = new HttpRequest<PharmacyInput>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Geocode`;
        httpRequest.body = input;

        const response = this.serviceProxy.post<PharmacyInput, Geocode>(httpRequest);
        return response;
    }

    /*
      Pharmacy
    */

    // [HttpGet, Route("Pharmacy/Address")]
    // public IActionResult GetByAddress(string ClientID, int Distance, string Address, string Name, string GroupID)
    getPharmacyByAddress(clientId: string, distance: number, address: string, name: string, groupId: string) {
        const httpRequest = new HttpRequest<DrugPricing>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Pharmacy/Address`;
        httpRequest.addQueryParameter('ClientID', clientId);
        httpRequest.addQueryParameter('Distance', distance.toString());
        httpRequest.addQueryParameter('Address', address);
        httpRequest.addQueryParameter('Name', name);
        httpRequest.addQueryParameter('GroupID', groupId);

        const response = this.serviceProxy.post<{}, Pharmacy>(httpRequest);
        return response;
    }

    // [HttpGet, Route("Pharmacy")]
    // public IActionResult Get(string ClientID, float Latitude, float Longitude, int Distance, string Name, string GroupID)
    getPharmacy(clientId: string, latitude: number, longitude: number, distance: number, name: string, groupId: string) {
        const httpRequest = new HttpRequest<DrugPricing>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Pharmacy`;
        httpRequest.addQueryParameter('ClientID', clientId);
        httpRequest.addQueryParameter('Latitude', latitude.toString());
        httpRequest.addQueryParameter('Longitude', longitude.toString());
        httpRequest.addQueryParameter('Distance', distance.toString());
        httpRequest.addQueryParameter('Name', name);
        httpRequest.addQueryParameter('GroupID', groupId);

        const response = this.serviceProxy.post<{}, Pharmacy>(httpRequest);
        return response;
    }

    // [HttpPost, Route("Pharmacy/Square")]
    // public IActionResult GetBySquare([FromBody]Square GeoCodes)
    getPharmacyBySquare(geocodes: BoundingBox) {
        const httpRequest = new HttpRequest<BoundingBox>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Pharmacy/Square`;
        httpRequest.body = geocodes;

        const response = this.serviceProxy.post<BoundingBox, Array<Pharmacy>>(httpRequest);
        return response;
    }

    getPharmacyByRadius(geocodes: BoundingRadius) {
        const httpRequest = new HttpRequest<BoundingRadius>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Pharmacy/Radius`;
        httpRequest.body = geocodes;

        const response = this.serviceProxy.post<BoundingRadius, Array<Pharmacy>>(httpRequest);
        return response;
    }

    // [HttpPost, Route("Pharmacy/new")]
    // public IActionResult ProcessNewPharmacies([FromBody] List<PhdemDto> Pharmacies)
    processNewPharmacies(pharmacies: Array<Phdem>) {
        const httpRequest = new HttpRequest<Array<Phdem>>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Pharmacy/new`;
        httpRequest.body = pharmacies;

        const response = this.serviceProxy.post<Array<Phdem>, {}>(httpRequest);
        return response;
    }

    // [HttpPost, Route("Pharmacy/new/network")]
    // public IActionResult ProcessNewPharmacyNetwork([FromBody] PharmacyNetworkDto NetworkPharmacy)
    processNewPharmacyNetwork(networkPharmacy: PharmacyNetwork) {
        const httpRequest = new HttpRequest<PharmacyNetwork>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Pharmacy/new/network`;
        httpRequest.body = networkPharmacy;

        const response = this.serviceProxy.post<PharmacyNetwork, {}>(httpRequest);
        return response;
    }

    // [HttpPost, Route("Pharmacy/new/groups"), DisableRequestSizeLimit]
    // public IActionResult ProcessNewPharmacyGroups([FromBody]List<GroupDataDto> Groups)
    processNewPharmacyGroups(groups: Array<GroupData>) {
        const httpRequest = new HttpRequest<Array<GroupData>>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.POST;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/Pharmacy/new/groups`;
        httpRequest.body = groups;

        const response = this.serviceProxy.post<Array<GroupData>, {}>(httpRequest);
        return response;
    }

    // [HttpGet("States")]
    // public IActionResult Get()
    getStates() {
        const httpRequest = new HttpRequest<{}>();
        httpRequest.token = this.accessToken;
        httpRequest.verb = HttpRequestVerbs.GET;
        httpRequest.uri.host.name = 'PharmacyLocator';
        httpRequest.uri.path = `/States`;

        const response = this.serviceProxy.post<{}, Array<State>>(httpRequest);
        return response;
    }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/pharmacy-locator/pharmacy-locator.service.ts